import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { addToCartItem } from '@jspartials/cart-utils';
import { body } from '@jspartials/general-utils';
import { notifyAfterAddedToCartSuccessfullyInProductDetails } from '@jscomponents/notification';

// Selectors
const selector = {
  button: {
    addToCart: '.js-button-add-to-cart',
    optionsAddToCart: '.js-button-options-add-to-cart'
  },
  addToCartButtonText: '.js-button-add-to-cart__text',
  addToCartButtonTextModal: '.js-button-add-to-cart__text-modal'
};

// Elements
const element = {};

// Variables
const timeoutToHideStatusClassnamesOnAddToCartButton = 3000;
let isBusy = false;

const listenAddToCartButton = () => {
  initElements();

  if (element.button.addToCart) {
    listenDOMEvent(element.button.addToCart, 'click', clickOnAddToCartButton);
  }

  if (element.button.optionsAddToCart) {
    listenDOMEvent(
      element.button.optionsAddToCart,
      'click',
      clickOnAddToCartOptionsButton
    );
  }
};

/**
 * Initialize the elements
 */
const initElements = () => {
  element.button = {
    addToCart: document.querySelector(selector.button.addToCart) || null,
    optionsAddToCart:
      document.querySelector(selector.button.optionsAddToCart) || null
  };
  element.addToCartButtonText =
    document.querySelector(selector.addToCartButtonText) || null;
  element.addToCartButtonTextModal =
    document.querySelector(selector.addToCartButtonTextModal) || null;
};

function getOptions(container) {
  var options;
  var optionsModal = document.querySelector('#productOptionsModal');
  var composableModal = document.querySelector(
    '#productComposableOptionsModal'
  );

  if (optionsModal) {
    if (document.querySelector('.js-options-step[data-step-id="complete"]')) {
      const optionsValues = document.querySelectorAll(
        '#productOptionsModal .option-value'
      );
      options = Array.from(optionsValues).map((option) => {
        return {
          optionId: option.name,
          selectedValueId: option.value
        };
      });
    }
  } else if (composableModal) {
    if (document.querySelector('.options-step[data-step-id="complete"]')) {
      const optionsValues = document.querySelectorAll(
        '#productComposableOptionsModal .option-value'
      );
      options = Array.from(optionsValues).map((option) => {
        return {
          optionId: option.name,
          selectedValueId: option.value,
          imageOptionId: option.dataset.image,
          optionTitle: option.dataset.title,
          optionDValue: option.dataset.displayvalue
        };
      });
    }
  } else {
    options = container
      .find('.product-option')
      .map(function () {
        var $elOption = $(this).find('.options-select');
        var urlValue = $elOption.val();
        var selectedValueId = $elOption
          .find('option[value="' + urlValue + '"]')
          .data('value-id');
        return {
          optionId: $(this).data('option-id'),
          selectedValueId: selectedValueId
        };
      })
      .toArray();
  }
  return JSON.stringify(options);
}

const clickOnAddToCartButton = (event) => {
  const button = event.currentTarget;
  const productId = button.dataset.pid || null;
  const isGlassesProduct = JSON.parse(button.dataset.isGlassesProduct) || false;
  const isComposableProduct =
    JSON.parse(button.dataset.isComposableProduct) || false;
  const isContactLensesProduct =
    JSON.parse(button.dataset.isContactLensesProduct) || false;

  if (isGlassesProduct || isComposableProduct) {
    body.dispatchEvent(new CustomEvent('product:selectOptionsModal'));
  } else if (isContactLensesProduct) {
    document.dispatchEvent(new CustomEvent('addToCartContactLenses'));
  } else if (productId && !isBusy) {
    isBusy = true;
    setLoadingAddToCartButton(button);

    addToCartItem(productId, 1, '', [])
      .then(() => {
        setSuccessAddToCart(button);
        notifyAfterAddedToCartSuccessfullyInProductDetails(productId);
      })
      .catch((error) => {
        setErrorAddToCart(button);
        console.error(error);
      });
  }
};
const clickOnAddToCartOptionsButton = (event) => {
  const button = event.currentTarget;
  const productId = button.dataset.pid || null;
  var options;
  if (productId && !isBusy) {
    isBusy = true;
    setLoadingAddToCartButton(button);

    var $productContainer = $(this).closest('.product-detail');
    if (!$productContainer.length) {
      $productContainer = $(this)
        .closest('.quick-view-dialog')
        .find('.product-detail');
    }
    options = getOptions($productContainer);
    addToCartItem(productId, 1, '', options)
      .then((data) => {
        setSuccessAddToCart(button);
        document.body.dispatchEvent(
          new CustomEvent('product:afterAddToCart', {
            detail: {
              data: data
            }
          })
        );
      })
      .catch((error) => {
        setErrorAddToCart(button);
        console.error(error);
      });
  }
};

/**
 * Set the success status on the add to cart button
 * @returns {void}
 */
const setSuccessAddToCart = (addToCartButton) => {
  unsetLoadingAddToCartButton(addToCartButton);
  addClassToElement(addToCartButton, classes.has.success);
  element.addToCartButtonText.innerText =
    addToCartButton.dataset.messageAddToCartSuccess;
  if (element.addToCartButtonTextModal) {
    element.addToCartButtonTextModal.innerText =
      addToCartButton.dataset.messageAddToCartSuccess;
  }
  resetAddToCartButton(addToCartButton);
};

/**
 * Set the error status on the add to cart button
 * @returns {void}
 */
const setErrorAddToCart = (addToCartButton) => {
  unsetLoadingAddToCartButton(addToCartButton);
  addClassToElement(addToCartButton, classes.has.error);
  element.addToCartButtonText.innerText =
    addToCartButton.dataset.messageAddToCartError;
  if (element.addToCartButtonTextModal) {
    element.addToCartButtonTextModal.innerText =
      addToCartButton.dataset.messageAddToCartError;
  }
  resetAddToCartButton(addToCartButton);
};

/**
 * Reset the add to cart button to its initial state
 * @returns {void}
 */
const resetAddToCartButton = (addToCartButton) => {
  setTimeout(() => {
    const buttonInnerText =
      addToCartButton.dataset.messagePreorder.trim() !== ''
        ? addToCartButton.dataset.messagePreorder
        : addToCartButton.dataset.messageAddToCart;

    removeClassToElement(addToCartButton, classes.has.success);
    removeClassToElement(addToCartButton, classes.has.error);

    element.addToCartButtonText.innerText = buttonInnerText;
    isBusy = false;
  }, timeoutToHideStatusClassnamesOnAddToCartButton);
};

const setLoadingAddToCartButton = (button) => {
  addClassToElement(button, classes.is.loading);
};

const unsetLoadingAddToCartButton = (button) => {
  removeClassToElement(button, classes.is.loading);
};

/**
 * Enable the add to cart button and set the product id on it
 * @param {string} productId - The product id
 * @returns {void}
 */
const enableAddToCartButton = (productId = null) => {
  initElements();

  if (element.button.addToCart && element.addToCartButtonText) {
    if (productId) {
      element.button.addToCart.dataset.pid = productId;
    }
    element.button.addToCart.disabled = false;
    element.addToCartButtonText.innerText =
      element.button.addToCart.dataset.messageAddToCart;
  }
};

/**
 * Disable the add to cart button and set the call to action message on it
 * @param {string} message - The call to action message
 * @returns {void}
 */
const disableAddToCartButton = (message = 'add-to-cart') => {
  initElements();

  if (element.button.addToCart && element.addToCartButtonText) {
    element.button.addToCart.disabled = true;
    element.addToCartButtonText.innerText =
      element.button.addToCart.getAttribute(`data-message-${message}`);
  }
};

export {
  listenAddToCartButton,
  enableAddToCartButton,
  disableAddToCartButton,
  setLoadingAddToCartButton,
  setSuccessAddToCart,
  setErrorAddToCart
};
